var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.546982 5.07655C0.479258 5.1441 0.425529 5.22435 0.388868 5.3127C0.352207 5.40105 0.333336 5.49576 0.333336 5.59141C0.333336 5.68707 0.352207 5.78178 0.388868 5.87013C0.425529 5.95848 0.479258 6.03873 0.546982 6.10628L4.91026 10.4696C5.04681 10.6061 5.23202 10.6828 5.42513 10.6828C5.61824 10.6828 5.80344 10.6061 5.94 10.4696C6.07655 10.333 6.15326 10.1478 6.15326 9.9547C6.15326 9.76158 6.07655 9.57638 5.94 9.43983L2.81734 6.31863L10.2728 6.31863C10.4657 6.31863 10.6506 6.24201 10.787 6.10563C10.9234 5.96925 11 5.78428 11 5.59141C11 5.39854 10.9234 5.21358 10.787 5.0772C10.6506 4.94082 10.4657 4.8642 10.2728 4.8642L2.81734 4.8642L5.94 1.743C6.07655 1.60645 6.15326 1.42124 6.15326 1.22813C6.15326 1.03502 6.07655 0.849816 5.94 0.713265C5.80345 0.576714 5.61824 0.5 5.42513 0.5C5.23202 0.5 5.04681 0.576714 4.91026 0.713265L0.546982 5.07655Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewBackIcon);
export default __webpack_public_path__ + "static/media/new_back_icon.dfeb49e2.svg";
export { ForwardRef as ReactComponent };